export default class CategoryAddController {
  constructor(ProductPagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
    "ngInject"
    this.activeTab = 1;
    this.page = {};
    this.type = 1;
    this.page.products = [];
    this.Upload = Upload;
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.APPLICATION_URL = APPLICATION_URL;
    this.errorShow = 0;
    ProductPagesDataProvider.editor();
  }

  setActiveTab(tabToSet) {
    this.activeTab = tabToSet;
    this.setEditorsData();
  }

onvertToSlug(text) {
  return text
    .toString()
    .normalize('NFKD')                // Bryt ner bokstäver med diakritiska tecken
    .replace(/[\u0300-\u036f]/g, '')  // Ta bort diakritiska tecken (accents)
    .toLowerCase()
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

  saveData(productForm, redirect) {
    let
      vm = this;
    vm.setEditorsData();
    vm.$timeout(function () {
      if (!productForm.$valid) {
        vm.errorShow = 1;
        vm.$timeout(function () {
          vm.errorShow = 0;
        }, 5000);
        return false;
      }
      if (vm.page.name)
        vm.page.slug = vm.onvertToSlug(vm.page.name);
      if (!vm.page.sub_category)
        vm.page.sub_category = 0;
      if (!vm.page.alt)
        vm.page.alt = vm.page.name;
      vm.page.type = vm.type;
      vm.page.parent_id = 0;
      if (vm.page.img) {
        vm.saveWithImage(vm.page.img, redirect);
      }
      else {
        let
          saveData = vm.ProductPagesDataProvider.saveCategory(vm.page);
        saveData.then(function (res) {
          if (redirect == '1') {
            if (res.id != undefined)
              vm.$state.go("app.categoryEdit", {id: res.id, tabId: vm.activeTab});
            else
              alert('Please try again.')
          }
          else {
            vm.$state.go("app.categoryList", {parentId: 'all'});
          }
        })
      }

    }, 5);
  }

  saveWithImage(file, redirect) {
    let
      vm = this;
    file.upload = vm.Upload.upload({
      url: vm.API_URL + '/productPage/saveProductPageImage',
      method: 'POST',
      data: {
        filename: new Date().valueOf() + file.name,
        file: file
      }
    });
    file.upload.then(function (response) {
      let data = vm.page;
      data.img = vm.APPLICATION_URL + response.data;
      let
        result = vm.ProductPagesDataProvider.saveCategory(data);
      result.then(function (res) {
        if (redirect == '1') {
          if (res.id != undefined)
            vm.$state.go("app.categoryEdit", {id: res.id, tabId: vm.activeTab});
          else
            alert('Please try again.')
        }
        else {
          vm.$state.go("app.categoryList", {parentId: 'all'});
        }
      })
    }, function (response) {
      if (response.status > 0)
        alert(response.status + ': ' + response.data);
    });
    //    file.upload.progress(function (evt) {
    //      vm.file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    //    });
  }

  setEditorsData() {
    this.page.shortText = tinyMCE.get('shortText').getContent();
    this.page.templateText = tinyMCE.get('templateText').getContent();
    this.page.longText = tinyMCE.get('longText').getContent();
    this.page.metaData = tinyMCE.get('metaData').getContent();
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/components/category_add/controller.js
 **/